/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ContentMasterBulkReviewFieldView = {
    /**
     * Field API name as used by /generate, /save-draft, /apply (for `marketplace` this is the mpAttr_* field key)
     */
    apiName?: string;
    /**
     * Field type discriminator
     */
    type?: ContentMasterBulkReviewFieldView.type;
    /**
     * Localized field label from Wawi for `wawiAttr`/`wawiMerkmal` (cName / merkmalName). `null` for `core` — frontend keys these by `apiName` for i18n.
     */
    label?: string | null;
    /**
     * Current Wawi value in this language. For `core` / `wawiAttr` — the raw text. For `wawiMerkmal` — the LOCALIZED LABEL (e.g. "Schwarz"); the underlying `kMerkmalWert` id lives in `kMerkmalWertOriginal`. Falls back to the raw id stringified when no cached label is available. Null when no original was snapshotted.
     */
    original?: string | null;
    /**
     * Latest stored draft (the value that will be written to Wawi when bulk apply runs). Same labelling rule as `original` — for `wawiMerkmal` this is the LOCALIZED LABEL of the chosen `kMerkmalWert` (id in `kMerkmalWertGenerated`).
     */
    generated?: string | null;
    /**
     * `tArtikelAttribut.kArtikelAttribut` for `wawiAttr` rows.
     */
    kArtikelAttribut?: number | null;
    /**
     * `tMerkmal.kMerkmal` for `wawiMerkmal` rows.
     */
    kMerkmal?: number | null;
    /**
     * First `kMerkmalWert` of the current Wawi value (sorted ASC). Convenience copy of `kMerkmalWerteOriginal[0]`. (wawiMerkmal only)
     */
    kMerkmalWertOriginal?: number | null;
    /**
     * First `kMerkmalWert` of the generated draft (sorted ASC). Convenience copy of `kMerkmalWerteGenerated[0]`. (wawiMerkmal only)
     */
    kMerkmalWertGenerated?: number | null;
    /**
     * All `kMerkmalWert` ids of the current Wawi value, sorted ASC. Multi-value Merkmal may have several; single-value has one; cleared/missing fields are `null`. (wawiMerkmal only)
     */
    kMerkmalWerteOriginal?: Array<number> | null;
    /**
     * All `kMerkmalWert` ids of the generated draft, sorted ASC. Same shape rules as `kMerkmalWerteOriginal`. (wawiMerkmal only)
     */
    kMerkmalWerteGenerated?: Array<number> | null;
    /**
     * Real SCX attribute id (SCX.tCategoryAttribute / tChannelAttribute .cAttributeId). (marketplace only)
     */
    cAttributeId?: string | null;
    /**
     * Attribute origin: `category` = attribute of the selected marketplace category, `channel` = marketplace-wide Verkaufskanäle attribute of the sales channel. (marketplace only)
     */
    level?: ContentMasterBulkReviewFieldView.level | null;
    /**
     * The marketplace's filling recommendation for this attribute (Wawi info-icon tooltip, SCX cDescription; truncated to 1000 chars in this snapshot). (marketplace only)
     */
    description?: string | null;
    /**
     * Whether the attribute is required ("Pflichtfeld"). (marketplace only)
     */
    required?: boolean | null;
    /**
     * Whether the attribute is recommended. (marketplace only)
     */
    recommended?: boolean | null;
    /**
     * Whether multiple values are allowed (comma-separated). (marketplace only)
     */
    multiple?: boolean | null;
    /**
     * Enum value + localized label pairs (empty for free-text). Render the label, store the value. (marketplace only)
     */
    allowedOptions?: Array<{
        value?: string;
        label?: string;
    }>;
};
export namespace ContentMasterBulkReviewFieldView {
    /**
     * Field type discriminator
     */
    export enum type {
        CORE = 'core',
        WAWI_ATTR = 'wawiAttr',
        WAWI_MERKMAL = 'wawiMerkmal',
        MARKETPLACE = 'marketplace',
    }
    /**
     * Attribute origin: `category` = attribute of the selected marketplace category, `channel` = marketplace-wide Verkaufskanäle attribute of the sales channel. (marketplace only)
     */
    export enum level {
        CATEGORY = 'category',
        CHANNEL = 'channel',
    }
}

